export default __webpack_public_path__ + "static/media/wbtc.2d930bb6.svg";